import { render, staticRenderFns } from "./homeContracts.vue?vue&type=template&id=c0ccbd08&scoped=true&"
import script from "./homeContracts.vue?vue&type=script&lang=js&"
export * from "./homeContracts.vue?vue&type=script&lang=js&"
import style0 from "./homeContracts.vue?vue&type=style&index=0&id=c0ccbd08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ccbd08",
  null
  
)

export default component.exports